const buildProviders = (
  list_data,
  components,
  handleButtonClick,
  action,
  screenName,
  settings
) =>
  list_data &&
  list_data.map(provider => {
    const { subtitle } = provider.cell_data;
    const subtitleParts = subtitle.split("\n");

    let earliestAvailability;

    subtitleParts.forEach(item => {
      if (item.startsWith("Earliest Availability: ")) {
        // eslint-disable-next-line no-useless-escape
        earliestAvailability = item.replace(/.*?\:\s(.*?)$/g, "$1");
      }
    });

    // eslint-disable-next-line new-cap
    return components.Provider({
      provider: {
        ...provider,
        detail_data: {
          ...provider.detail_data,
          earliestAvailability
        }
      },
      components,
      settings,
      screenName,
      onSelect: data => handleButtonClick("selectedData", data, action),
      onViewProfile: name =>
        handleButtonClick("provider_profile", name, {
          type: "modal_screen",
          value: "ConsultationBhProviderProfile"
        })
    });
  });

export default buildProviders;
